import axios from "axios";

const api = axios.create();

api.interceptors.request.use((config) => {
    const token = sessionStorage.getItem("token");

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

// SM-AUTH-HR: Authorization header for screens that call the API with
// fetch() instead of the axios instance above (report and admin pages).
// Spread it into fetch's headers. REVERT: delete this function and its uses.
export function authHeader() {
    const token = sessionStorage.getItem("token");
    return token ? { Authorization: `Bearer ${token}` } : {};
}

export default api;